import { render, staticRenderFns } from "./AdminKeywords.vue?vue&type=template&id=36daf1d3&scoped=true&"
import script from "./AdminKeywords.vue?vue&type=script&lang=js&"
export * from "./AdminKeywords.vue?vue&type=script&lang=js&"
import style0 from "./AdminKeywords.vue?vue&type=style&index=0&id=36daf1d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36daf1d3",
  null
  
)

export default component.exports